import { useDocs } from 'data/data'

import Button from 'features/portal/Button'

function Header() {
    const { docs, isLoading, stats, apiUrl } = useDocs()

    let exportCsvEndpoint = apiUrl + "/csv"
    let documentCountBadge = null
    let statuteCountBadges = null

    if (isLoading === false) {
        documentCountBadge = <span className="results-count-badge">{stats.count.toLocaleString()} documents</span>

        statuteCountBadges = Object.keys(stats.statuteCount).map((a) => {
            let val = stats.statuteCount[a]
            if (val === 0)
                return null
            return <span className={"badge " + a.toLowerCase()} key={a}>{val.toLocaleString()} {a}</span>
        })

    }

    return (
        <>
            <div id="document-section-header">
                <div className="dashboard-kicker">
                    Eyes on Environmental Enforcement Records
                </div>

                <div className="results-title">
                    <i className="ti ti-files"></i>
                    <span>Document Results</span>
                    { documentCountBadge }
                    { statuteCountBadges }
                </div>
            </div>

            <div className="results-tools">
                <Button isPrimary={true} href={exportCsvEndpoint}>Export CSV</Button>
            </div>
        </>
    )
}

export default Header;